"use strict";
/**
 * Check if dropdown2 is child of dropdown2 component and
 * prevent closing parent dropdown2 if user is selecting
 * child dropdown2 value
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.dropdownOnChange = void 0;
var checkParentElement = function (elem) {
    return elem && elem.parentElement ? getDropDownParent(elem.parentElement) : null;
};
var getDropDownParent = function (elem) {
    return elem.classList.contains('sok-dropdown2-menu')
        ? elem
        : checkParentElement(elem.parentElement);
};
var dropdownOnChange = function (isOpen, setIsOpen) {
    return function (value, e) {
        var elem = getDropDownParent(e.target);
        if (elem) {
            return;
        }
        if (isOpen) {
            if (e.target && e.target.parentNode && value !== isOpen) {
                return setIsOpen(value);
            }
            return;
        }
        setIsOpen(value);
    };
};
exports.dropdownOnChange = dropdownOnChange;
